/* global axios */
import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  // Sends the WhatsApp template to a single number as a test (before publishing).
  sendTest({ inboxId, templateParams, phoneNumber }) {
    return axios.post(`${this.url}/send_test`, {
      inbox_id: inboxId,
      template_params: templateParams,
      phone_number: phoneNumber,
    });
  }
}

export default new CampaignsAPI();
